<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-table-data titulo="Información del Comprobante" :datos="ventaDatos"/>

        <b-card header="Certificados de Servicio" v-if="ventaRenglonesDatos.length != 0">
          <b-table
            small
            responsive="sm"
            class="registro-ordenes"
            :items="ventaRenglonesDatos"
            :fields="fieldsRenglones">
            <template v-slot:cell(cotizacion)="data">
              {{ data.item.cotizacion | moneda(ventaDatosMoneda) }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(ventaDatosMoneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Comprobantes Asociados" v-if="ventaAsociadasDatos.length != 0">
          <b-table
            small
            responsive="sm"
            class="registro-ordenes"
            :items="ventaAsociadasDatos"
            :fields="fieldsAsociadas">
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Referencias" v-if="ventaReferenciasDatos.length != 0">
          <b-table
            small
            responsive="sm"
            class="registro-ordenes"
            :items="ventaReferenciasDatos"
            :fields="fieldsReferencias">
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Información de Impresión">
          <b-table
            small
            responsive="sm"
            class="registro-ordenes"
            :items="ventaRenglonesDescripcionDatos"
            :fields="fieldsRenglonesDescripcion">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(ventaDatosMoneda) }}
            </template>
          </b-table>
        </b-card>

        <app-table-data titulo="Venta Negociada" :datos="ventaNegociacionDatos" v-if="ventaNegociacionDatos && ventaNegociacionDatos.length != 0"/>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
        <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <b-modal
      title="SGC"
      :header-bg-variant="msjModalVariant"
      v-model="msjModalVisible"
      ok-only
      ok-variant="primary footer-button">
      {{ msjModal }}
    </b-modal>
  </div>
</template>

<script>
import TableData from '../shared/tableData'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'venta/getField',
  mutationType: 'venta/updateField',
})

export default {
  name: 'Venta',
  components: {
    appTableData: TableData
  },
  data: () => {
    return {
      ventaId: 0,
      fields: [{ key: 'campo' }, { key: 'valor' }],

      fieldsRenglones: [
        {
          key: 'certificadoServicio',
          label: 'Nro.Certificado',
        },
        {
          key: 'presupuestoNumero',
          label: 'Nro.Presupuesto',
        },
        {
          key: 'ordenCompra',
          label: 'Nro.Orden Compra',
        },
        {
          key: 'cotizacion',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      fieldsRenglonesDescripcion: [
        {
          key: 'descripcion',
          label: 'Descripción',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      fieldsAsociadas: [
        {
          key: 'causa',
          label: 'Concepto',
          // sortable: true
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.',
          sortable: true,
        },
        {
          key: 'comprobante',
          sortable: true,
        },
        {
          key: 'total',
          class: 'text-right',
        },
        {
          key: 'cae',
          label: 'CAE',
        },
      ],

      fieldsReferencias: [
        {
          key: 'causa',
          label: 'Concepto',
          // sortable: true
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.',
          sortable: true,
        },
        {
          key: 'comprobante',
          sortable: true,
        },
        {
          key: 'total',
          class: 'text-right',
        },
        {
          key: 'cae',
          label: 'CAE',
        },
      ],

      msjModalVisible: false,
      msjModal: '',
      msjModalVariant: 'light',
    }
  },
  created() {
    this.ventaId = this.$route.params.id

    this.$store.dispatch('venta/getDatos', this.ventaId)
  },
  computed: {
    ...mapFields([
      'ventaDatos',
      'ventaRenglonesDatos',
      'ventaRenglonesDescripcionDatos',
      'ventaAsociadasDatos',
      'ventaReferenciasDatos',
      'ventaDatosMoneda',
      'ventaNegociacionDatos',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>